import { ChangePasswordContainer } from "../../containers/Profile/ChangePasswordContainer";

export function ChangePasswordPage() {
    return (
        <ChangePasswordContainer />
    )
}